import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Code2 } from "lucide-react";
import { http } from "../lib/api";

const area = "w-full border border-slate-800 bg-[#0d0c11] px-4 py-3 font-mono-d text-xs leading-relaxed text-white outline-none focus:border-rose-500";

export const SiteCodeEditor = () => {
  const [code, setCode] = useState({ head_code: "", body_code: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    http.get("/site-code").then((r) => setCode({ head_code: r.data?.head_code ?? "", body_code: r.data?.body_code ?? "" })).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await http.put("/admin/site-code", code);
      toast.success("Código salvo. Já está ativo no site.");
    } catch {
      toast.error("Falha ao salvar o código");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="mt-16 border-t border-white/5 pt-12" data-testid="site-code-editor">
      <h2 className="font-serif-d flex items-center gap-3 text-3xl text-white"><Code2 className="text-rose-500" /> Código personalizado</h2>
      <p className="mb-8 mt-2 text-sm text-slate-300">Cole aqui códigos de redes de anúncios (ExoClick, JuicyAds, TrafficStars...), pop-unders, verificações e estatísticas. O código é carregado em todas as páginas públicas.</p>
      <div className="grid gap-8 lg:grid-cols-2">
        <label className="block">
          <span className="eyebrow mb-2 block !text-slate-400">Código no &lt;head&gt;</span>
          <textarea rows={10} value={code.head_code} onChange={(e) => setCode({ ...code, head_code: e.target.value })} placeholder={'<script src="https://..."></script>\n<meta name="..." content="...">'} className={area} spellCheck={false} data-testid="head-code-input" />
        </label>
        <label className="block">
          <span className="eyebrow mb-2 block !text-slate-400">Código antes do &lt;/body&gt;</span>
          <textarea rows={10} value={code.body_code} onChange={(e) => setCode({ ...code, body_code: e.target.value })} placeholder={'<script type="text/javascript">...</script>'} className={area} spellCheck={false} data-testid="body-code-input" />
        </label>
      </div>
      <button onClick={save} disabled={saving} className="mt-6 bg-rose-600 px-6 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-white hover:bg-rose-500 disabled:opacity-50" data-testid="site-code-save-button">
        {saving ? "Salvando..." : "Salvar código"}
      </button>
    </section>
  );
};
